import { defineRecipe } from '@chakra-ui/react'

export const separatorRecipe = defineRecipe({
    variants: {
        variant: {
            gigi: {
                height: '1px',
                _light: {
                    background: 'gray.300',
                },
                _dark: {
                    background: 'gray.700',
                },
            },
            citations: {
                height: '1px',
                _light: {
                    background: 'gray.300',
                },
                _dark: {
                    background: 'gray.700',
                },
            },
        },
    },
})
